import { render, staticRenderFns } from "./StudentsTable.vue?vue&type=template&id=9bcd547e"
import script from "./StudentsTable.vue?vue&type=script&lang=ts"
export * from "./StudentsTable.vue?vue&type=script&lang=ts"
import style0 from "./StudentsTable.vue?vue&type=style&index=0&id=9bcd547e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports